import { $ as jquery } from 'jquery';

var $ = jquery;

var getViewportSize = function () {
  var doc = document.documentElement || {};
  return {
    width: window.innerWidth || doc.clientWidth || 990,
    height: window.innerHeight || doc.clientHeight || 700,
  };
};

var getMediaManageLayerOptions = function () {
  var viewport = getViewportSize();
  var isCompact = viewport.width <= 992;

  if (!isCompact) {
    return {
      area: ['990px', '700px'],
      offset: 'auto',
    };
  }

  var padding = 8;
  var width = Math.max(viewport.width - padding * 2, 0);
  var height = Math.max(viewport.height - padding * 2, 0);

  return {
    area: [width + 'px', height + 'px'],
    offset: padding + 'px',
  };
};

var getMediaDialogFormOptions = function () {
  var viewport = getViewportSize();
  var isCompact = viewport.width <= 768;
  var width = isCompact ? Math.max(viewport.width - 24, 280) : 470;

  return {
    area: [Math.round(width) + 'px', 'auto'],
    skin: 'layui-layer-g3ys-form media-subdialog-layer',
  };
};

var createMediaFormFieldHtml = function (options) {
  var html = '';
  html += '<div class="media-subdialog-body">';
  html += '<div class="layui-form-item media-subdialog-form-item">';
  html += '<label class="layui-form-label">' + (options.label || '') + '</label>';
  html += '<div class="layui-input-block">';
  html += options.fieldHtml || '';
  html += '</div>';
  html += '</div>';
  html += '</div>';
  return html;
};

var createMediaConfirmHtml = function (message) {
  return (
    "<div class='media-subdialog-body media-subdialog-confirm'><div class='layui-layer-g3ys-form-info'><i>!</i>" +
    message +
    '</div></div>'
  );
};

var createMediaDialogFooter = function (options) {
  var html = '';
  html += '<div class="media-manage-footer">';
  html += '<div class="media-manage-footer-left">';
  html += options.actionsHtml || '';
  html += '</div>';
  html += '<div class="media-manage-footer-right">';
  html += '<a href="javascript:;" class="layui-btn layui-btn-sm media-manage-confirm" id="' + options.confirmId + '">' + options.confirmText + '</a>';
  html += '<a href="javascript:;" class="layui-btn layui-btn-primary layui-btn-sm media-manage-cancel" id="' + options.cancelId + '">' + options.cancelText + '</a>';
  html += '</div>';
  html += '</div>';
  return html;
};

var createMediaMobileBar = function (options) {
  var html = '';
  html += '<div class="media-manage-mobile-bar">';
  if (options.categoryTriggerId) {
    html +=
      '<a href="javascript:;" class="layui-btn layui-btn-primary layui-btn-sm media-manage-mobile-toggle media-manage-mobile-category-trigger" id="' +
      options.categoryTriggerId +
      '">' +
      '<i class="layui-icon layui-icon-spread-left"></i>' +
      '<span>' +
      (options.categoryText || '') +
      '</span></a>';
  }
  html +=
    '<a href="javascript:;" class="layui-btn layui-btn-primary layui-btn-sm media-manage-mobile-toggle media-manage-mobile-search-trigger" id="' +
    options.searchTriggerId +
    '">' +
    '<i class="layui-icon layui-icon-search"></i>' +
    '<span>' +
    (options.searchText || '') +
    '</span></a>';
  html += '</div>';
  return html;
};

var bindMediaDialogFooter = function (options) {
  $('#' + options.confirmId).off('click').on('click', function (event) {
    event.preventDefault();
    options.onConfirm && options.onConfirm();
  });
  $('#' + options.cancelId).off('click').on('click', function (event) {
    event.preventDefault();
    options.onCancel && options.onCancel();
  });
};

var bindMediaMobilePanels = function (options) {
  var $shell = $('#' + options.shellId);
  if (!$shell.length) {
    return {
      closeCategory: function () {},
      closeSearch: function () {},
    };
  }

  var setState = function (name, open) {
    $shell.attr('data-mobile-' + name, open ? 'open' : 'closed');
    var triggerId = name === 'category' ? options.categoryTriggerId : options.searchTriggerId;
    if (triggerId) {
      $('#' + triggerId).toggleClass('is-active', !!open);
    }
  };

  setState('search', false);
  if (options.categoryTriggerId) {
    setState('category', false);
  }

  if (options.categoryTriggerId) {
    $('#' + options.categoryTriggerId)
      .off('click')
      .on('click', function (event) {
        event.preventDefault();
        var isOpen = $shell.attr('data-mobile-category') === 'open';
        setState('category', !isOpen);
        if (!isOpen) {
          setState('search', false);
        }
      });
  }

  $('#' + options.searchTriggerId)
    .off('click')
    .on('click', function (event) {
      event.preventDefault();
      var isOpen = $shell.attr('data-mobile-search') === 'open';
      setState('search', !isOpen);
      if (!isOpen && options.categoryTriggerId) {
        setState('category', false);
      }
    });

  return {
    closeCategory: function () {
      options.categoryTriggerId && setState('category', false);
    },
    closeSearch: function () {
      setState('search', false);
    },
  };
};

var createMediaSelectionHelper = function (options) {
  var getSelectedItems = options.getSelectedItems;
  var getItems = options.getItems;
  var selectClass = options.selectClass;
  var setSelectedCount = options.setSelectedCount || function () {};
  var setSelectAllChecked = options.setSelectAllChecked || function () {};
  var onLimit = options.onLimit || function () {};
  var getSingleSelected = options.getSingleSelected || function () {
    return {};
  };
  var setSingleSelected = options.setSingleSelected || function () {};
  var setSelectedItems = options.setSelectedItems || function () {};

  var removeSelectionById = function (id) {
    var selectedItems = getSelectedItems();
    for (var i = selectedItems.length - 1; i >= 0; i--) {
      if (selectedItems[i].id == id) {
        selectedItems.splice(i, 1);
      }
    }
  };

  var updateSelectedCount = function () {
    options.multiple && setSelectedCount(getSelectedItems().length);
  };

  var syncSelectAll = function () {
    if (!options.multiple) {
      return;
    }
    var items = getItems();
    setSelectAllChecked(!!items.length && !items.filter(':not(.' + selectClass + ')').length);
  };

  var applySelections = function () {
    if (!options.multiple) {
      return;
    }
    var items = getItems();
    var selectedItems = getSelectedItems();
    items.removeClass(selectClass);
    for (var i = 0; i < selectedItems.length; i++) {
      options.markSelected(selectedItems[i], i);
    }
    updateSelectedCount();
    syncSelectAll();
  };

  var setItemSelected = function (item, selected) {
    item = $(item);
    if (!options.multiple) {
      if (!selected) {
        item.removeClass(selectClass);
        setSingleSelected({});
        return true;
      }
      getItems().removeClass(selectClass);
      setSingleSelected(options.getItemData(item));
      item.addClass(selectClass);
      return true;
    }

    var selectedItems = getSelectedItems();
    if (selected) {
      if (item.hasClass(selectClass)) {
        return true;
      }
      if (selectedItems.length >= options.max) {
        onLimit();
        return false;
      }
      selectedItems.push(options.getItemData(item));
      item.addClass(selectClass);
    } else {
      if (!item.hasClass(selectClass)) {
        return true;
      }
      item.removeClass(selectClass);
      removeSelectionById(item.attr('data-id'));
    }
    setSelectedItems(selectedItems);
    updateSelectedCount();
    syncSelectAll();
    return true;
  };

  var bindItems = function () {
    getItems().off('click').on('click', function () {
      var item = $(this);
      setItemSelected(item, !item.hasClass(selectClass));
    });
    syncSelectAll();
  };

  var clearSelections = function () {
    if (options.multiple) {
      setSelectedItems([]);
      updateSelectedCount();
      setSelectAllChecked(false);
    } else {
      setSingleSelected({});
    }
    getItems().removeClass(selectClass);
  };

  return {
    updateSelectedCount: updateSelectedCount,
    syncSelectAll: syncSelectAll,
    applySelections: applySelections,
    setItemSelected: setItemSelected,
    bindItems: bindItems,
    clearSelections: clearSelections,
    getSingleSelected: getSingleSelected
  };
};

export { getMediaManageLayerOptions, getMediaDialogFormOptions, createMediaFormFieldHtml, createMediaConfirmHtml, createMediaMobileBar, bindMediaMobilePanels, createMediaSelectionHelper, createMediaDialogFooter, bindMediaDialogFooter };
